export default {
  resultLabel: "Errores y comentarios encontrados",
  columnNames: {
    origin: "Origen",
    fieldName: "Campo",
    validationType: "Tipo de validación",
    validationRule: "Regla de validación",
    ruleDescription: "Descripción regla",
    services: "Servicios",
    consecutive: "Consecutivo",
    patient: "Paciente",
  },
  emptyDataLabel: "No se encontraron resultados",
};
